export { default } from "./SearchErrorView";
